// extracted by mini-css-extract-plugin
export default {"horizontal":"Stack_horizontal__ZcJn3"};